module.exports = __webpack_public_path__ + "img/google-play-badge-black_2.3aec5b5a.svg";